import { Inject, Injectable } from '@angular/core';
import { Auth, getIdTokenResult, IdTokenResult, onIdTokenChanged } from '@angular/fire/auth';
import 'firebase/auth';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(@Inject(Auth) private fireAuth: Auth) {}

  public onIdTokenChanged$(callback): Promise<any> {
    return new Promise(onIdTokenChanged(this.fireAuth, callback));
  }

  public getToken$(): Observable<IdTokenResult> {
    return from(getIdTokenResult(this.fireAuth.currentUser));
  }
}
